import React, { useState, useEffect, Fragment } from "react";
import { BrowserRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Alert } from "reactstrap";
import Router from "../Router/Router";
import { getCurrentUser, getPermissions } from "../CurrentUser/actions/currentUser.actions";
import "bootstrap/dist/css/bootstrap.css";
import "../../scss/app.scss";
//import './App.css';
import { MdSentimentVeryDissatisfied, MdClear } from "react-icons/md";

const App = (props) => {
    const { dispatch, permissions, currentUser } = props;
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const loadPage = () => {
        window.addEventListener("load", () => {
            setLoading({ loading: false });
            setTimeout(() => setLoaded({ loaded: true }), 200);
        });
    };

    useEffect(() => {
        const getUser = () => {
            dispatch(getCurrentUser());
        };

        const getUserPermissions = () => {
            dispatch(getPermissions());
        };

        loadPage();
        getUser();
        getUserPermissions();
    }, [dispatch]);
    const hasError = currentUser.error || permissions.error;
    const isActive = currentUser?.response?.active;

    return (
        <BrowserRouter basename="/bulk-paycode-portal">
            {/* <ScrollToTop> */}
            <Fragment>
                {!loaded && (
                    <div className={`load${loading ? "" : " loaded"}`}>
                        <div className="load__icon-wrap">
                            <svg className="load__icon">
                                <path fill="#003553" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                            </svg>
                        </div>
                    </div>
                )}
                <div>
                    {hasError ? (
                        <div className="app-load-error">
                            <Alert color="danger">
                                <MdSentimentVeryDissatisfied size={40} />
                                <h4 className="font-weight-bold">Failed to load application</h4>
                                {currentUser.error && <p>Failed to load information for this user</p>}
                                {permissions.error && <p>Failed to load permissions for this user</p>}

                                <p>Please refresh your browser to try again</p>
                                <p>If this issue persists, please contact your administrator</p>
                            </Alert>
                        </div>
                    ) : null}
                    {isActive === false ? (
                        <div className="app-load-error">
                            <Alert color="light">
                                {/* <div style={{ backgroundColor: "red" }}>
                                    <MdWarning size={40} />
                                </div> */}
                                <MdClear size={20} style={{ color: "red", position: "absolute", right: "31px", cursor: "pointer" }} />
                                {/* <img src={alertLogo} style={{ width: "15%", marginBottom: "1rem" }} alt="alert-icon" /> */}

                                <h4 className="font-weight-bold mb-3" style={{ color: "red" }}>
                                    {" "}
                                    ACCESS DENIED!
                                </h4>
                                <h4 className="font-weight-bold" style={{ color: "black" }}>
                                    Your account has been disabled.
                                </h4>
                                <p style={{ color: "black", fontSize: "" }}>Please contact the administrator to enable access to Bulk Paycode Disbursement portal.</p>
                            </Alert>
                        </div>
                    ) : null}
                </div>
                <Router />
            </Fragment>
            {/* </ScrollToTop> */}
        </BrowserRouter>
    );
};

export default connect((state) => ({
    permissions: state.permissions,
    currentUser: state,
    currentUserStatus: state.getCurrentUserStatus,
}))(App);
